import api from "../../../api";

export default function getAssignedOrder(pageNumber = 1) {
  return api.get(`/patients?pageNumber=${pageNumber}`);
}

export function assignedOrderFilterData(queryParams){
  return api.get(`/assigned_orders?${queryParams}`)
}
